import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取归责树形数据
 * @param
 */
export const getAttributionTree = () => {
  return request({
    url: env.ferryUrl + '/complaint-suggestion/attribution/tree',
    method: 'GET'
  })
}

/**
 * 保存归责树形数据
 * @param data
 */
export const postAttributionSave = (data) => {
  return request({
    url: env.ferryUrl + '/complaint-suggestion/attribution/save',
    method: 'POST',
    data
  })
}

/**
 * 删除归责树形数据
 * @param data
 */
export const deleteAttributionDel = (data) => {
  return request({
    url: env.ferryUrl + `/complaint-suggestion/attribution/del?id=${data}`,
    method: 'DELETE'
  })
}
